export default "__VITE_ASSET__1ca35e8b__"